import { IApiResponse } from "../../../../@types/api-response.type"
import { IHardSkillsDto } from "../../../../@types/curriculum.type"
import { Api } from "../../ApiConfig"
import { ApiException } from "../../ApiException"
import { getErrorMessage } from "../../../../utils/utils"

export const getAllHardSkillReference = async () : Promise<IHardSkillsDto[]> => {
  try {
      const { data } = await Api.get<IApiResponse<IHardSkillsDto[]>>(`/api/HardSkill/GetAllHardSkillReference`)
      return data.result
  } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao consultar Hard Skills'))
  }  
}
